var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade",
      attrs: { tabindex: "-1", role: "dialog" }
    },
    [
      _c("div", { staticClass: "modal-dialog", attrs: { role: "document" } }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("h4", { staticClass: "modal-title" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "actions.actionDefinition.model.types." +
                      _vm.definition?.type
                  )
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _vm._v(
                  "\n          " + _vm._s(_vm.$t("txtDuty")) + "\n          "
                ),
                _c("vSelect", {
                  attrs: {
                    options: _vm.dutyStore.duties,
                    label: "title",
                    reduce: d => d.dutyId,
                    value: _vm.dutyId,
                    clearable: false,
                    disabled: true
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _vm._v(
                  "\n          " + _vm._s(_vm.$t("txtCell")) + "\n          "
                ),
                _c("vSelect", {
                  attrs: {
                    options: _vm.cellsForVSelect,
                    label: "name",
                    reduce: cell => cell.id,
                    clearable: true
                  },
                  model: {
                    value: _vm.cellId,
                    callback: function($$v) {
                      _vm.cellId = $$v
                    },
                    expression: "cellId"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("txtActivityReference")) +
                  "\n          "
              ),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.reference,
                    expression: "reference"
                  }
                ],
                staticClass: "form-control",
                domProps: { value: _vm.reference },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.reference = $event.target.value
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button" },
                on: { click: _vm.dismiss }
              },
              [_vm._v(_vm._s(_vm.$t("btnClose")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button", disabled: _vm.triggering },
                on: { click: _vm.trigger }
              },
              [
                _vm.triggering
                  ? _c("Spinner", { attrs: { small: true } })
                  : _vm._e(),
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("actions.triggerModal.trigger")) +
                    "\n        "
                )
              ],
              1
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }